import React from 'react';
import Dialog from '@material-ui/core/Dialog';

const DialogView = ({setShowModal, showModal, view, close}) => {

    return (
        <Dialog onClose={() => setShowModal(false)} open={showModal}>
            <div style={{
                width: 300,
                padding: 20
            }}>
                <h3 style={{
                    margin: 0,
                    padding: 0,
                    textAlign: 'center',
                    marginBottom: 12
                }}>Заявка № {view.id}</h3>
                <div>
                    <span style={{color: '#757575', fontWeight: 500}}>От кого: </span>
                    <span>{view.label_name} (<span style={{fontWeight: 700}}>{view.email}</span>)</span>
                </div>
                <div style={{display: 'flex', flexDirection: 'column'}}>
                    <span style={{color: '#757575', fontWeight: 500}}>Сообщение</span>
                    <span>{view.message}</span>
                </div>
                <div style={{display: 'flex', marginTop: 20}}>
                    <span 
                        onClick={() => {
                            setShowModal(false);
                            close()
                        }}
                        style={{background: 'rgba(255,195,37)', padding: '10px 15px', width: '100%', textAlign: 'center', cursor: 'pointer', borderRadius: 8}}>Закрыть</span>
                </div>
            </div>
        </Dialog>
    )
}

export default DialogView;